/*jshint esversion: 9 */
/*jshint sub:true*/
import { mapGetters, mapActions } from 'vuex';
import TWaggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
export const TWaggonMixin = {
  data: () => ({
    draggable_old_twaggon_id: -1,
  }),
  components: {
    TWaggon
  },
  computed: {
    ...mapGetters('TWaggon', [
      'getTWaggon',
      'getTWaggons',
    ]),
  },
  methods: {
    ...mapActions('TWaggon', [
      'deleteTWaggon',
      'setTWaggons',
      'tWorkPackageChangePosition',
      'tWorkPackageRemoveFromTWaggon',
      'tWorkPackageAddToWaggon',
    ]),
    openWaggonInfo(waggon, train_id, taktarea_id, waggon_id, evt, workpackage_id) {
      let x =  -window.innerWidth/2 + evt.clientX;
      let y = -window.innerHeight/2 + evt.clientY;
      document.body.style.setProperty('--waggon_offset_x', `${x}px`);
      document.body.style.setProperty('--waggon_offset_y', `${y}px`);
      if (waggon.tworkpackages.length > 0) {
        this.$router.push({
          name: this.isEditMode?'TaktPlanWorkPackageEdit':'TaktPlanWorkPackageInfo',
          params: {
            train_id: train_id,
            taktarea_id: taktarea_id,
            twaggon_id: waggon_id,
            tworkpackage_id: workpackage_id?workpackage_id:waggon.tworkpackages[0],
            }
          });
      } else if (this.isEditMode) {
        this.$router.push({
          name: 'TaktPlanAddWorkPackage',
          params: {
            train_id: train_id,
            taktarea_id: taktarea_id,
            twaggon_id: waggon_id,
            }
          });
      }
    },
    getDraggableStyle(){
      return {attrs: {'style': `width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom)); height: calc((var(--workpackage_height) + 4px) * var(--taktplan_zoom))`}};
    },
  }
};
